<template>
  <div style="width: 100%;height: 100%;background-color: white;">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%">
        <el-col :span="4" style="height: 100%;overflow-y: auto">
          <div style="margin: 0 20px;height: 50px">
            <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
          </div>
          <div style="margin: 0 20px;">
            <el-tree class="filter-tree" show-checkbox :data="treeData" :props="defaultProps" node-key="id" :default-expanded-keys="expandedKeys" :default-checked-keys="isFirst"
                     @node-click="handleTreeClick" @check-change="handleCheckChange" :filter-node-method="filterNode" ref="treeData">
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto">
          <div style="margin-right: 20px">
            <div style="height: 50px">
              <el-button v-if="isShowBindDevice" type="primary" plain @click="bindDevice()">绑定设备</el-button>
              <el-input prefix-icon="el-icon-search" placeholder="输入设备编号 / 设备号码 / 服务对象名称搜索" v-model="searchKeyword" style="width: 350px" @blur="blurSearch()"></el-input>
              <el-button icon="el-icon-search" type="primary" plain @click="searchWord()">搜索</el-button>
              <el-select v-fixZoom v-model="isonline" placeholder="请选择">
                <el-option v-for="item in isonlinearr" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select v-fixZoom v-model="dtype" style="width: 250px;" multiple placeholder="请选择">
                <el-option v-for="item in dtypearr" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button type="success" @click="queryDataTable">查询</el-button>
            </div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto;">
              <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="设备编号" min-width="130" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.devicetype !== 700">
                      {{scope.row.deviceid}}
                    </div>
                    <div v-else>
                      <el-tooltip placement="top" effect="dark">
                        <div slot="content">
                          <span style="font-size: 14px">版本号：</span>
                          <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                          <span style="font-size: 14px">雷达监测结果：</span>
                          <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                          <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                          <span style="font-size: 14px">雷达监测时间：</span>
                          <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                        </div>
                        <div>
                          <img style="vertical-align: sub;width: 20px;height: 20px"
                               src="../../../static/tableIcon/lie.png"
                               v-if="scope.row.radarstaus === 'tx'">
                          <img style="vertical-align: sub;width: 20px;height: 20px"
                               src="../../../static/tableIcon/walk.png"
                               v-if="scope.row.radarstaus === 'out'">
                          <span>{{scope.row.deviceid}}</span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="设备类型" min-width="95" align="center">
                  <template slot-scope="scope">
                    <span>{{getDeviceType(scope.row.devicetype)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="设备号码" min-width="100" align="center">
                  <template slot-scope="scope">
                    <span>{{getDevicePhone(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="电量" width="60" align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.battery}}%</span>
                  </template>
                </el-table-column>
                <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
                <el-table-column v-if="moduletag === 3" prop="h_address" label="家庭地址/机构房间" min-width="140" align="center"></el-table-column>
                <el-table-column v-else-if="moduletag === 2" prop="h_address" label="机构房间" min-width="140" align="center"></el-table-column>
                <el-table-column v-else-if="moduletag === 1" prop="h_address" label="家庭地址" min-width="140" align="center"></el-table-column>
                <el-table-column prop="h_installlocation" label="安装位置" min-width="75" align="center"></el-table-column>
                <el-table-column prop="p_name" label="服务对象" min-width="80" align="center"></el-table-column>
                <el-table-column label="离线警报" min-width="75" align="center">
                  <template slot-scope="scope">
                    {{getNoneWork(scope.row)}}
                  </template>
                </el-table-column>
                <el-table-column prop="userName" label="绑定者" min-width="80" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                  <template slot-scope="scope">
                    <img src="../../assets/tel/icon_replace.png"
                         title="更换设备"
                         style="width: 14px;vertical-align: baseline;margin-right: 3px;cursor: pointer"
                         @click="openChange(scope.row)">
                    <i v-if="scope.row.devicetype === 300 || scope.row.devicetype === 901 || scope.row.devicetype === 350"
                       title="历史位置"
                       style="cursor: pointer; font-size: 18px;"
                       class="el-icon-delete-location" @click="openTrackMap(scope.row)"></i>
                    <i title="设备日志"
                       style="cursor: pointer; font-size: 18px;"
                       class="el-icon-document" @click="openDeviceLog(scope.row)"></i>
                    <i v-if="scope.row.devicetype === 700 || scope.row.devicetype === 901"
                       style="cursor: pointer; font-size: 18px;color: blue"
                       title="设置设备"
                       class="el-icon-s-tools" @click="openList(scope.row)"></i>
                    <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
                    <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                             layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="650px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>绑定设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-add :addDeviceRow="addRow" v-model="addShow"  @getFatherDevice="getFatherDevice"></device-add>
    </el-dialog>
    <el-dialog :visible.sync="addShow1" v-if="addShow1" width="650px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>绑定设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-add1 :addDeviceRow="addRow" v-model="addShow1"  @getFatherDevice="getFatherDevice"></device-add1>
    </el-dialog>
    <!--update-->
    <el-dialog :visible.sync="editShow" v-if="editShow" :width="openWidth" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>编辑设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-edit :deviceEditRow="addRow" v-model="editShow" @getFatherEditDevice="getFatherEditDevice"></device-edit>
    </el-dialog>
    <!--子机、语音通知、电话本、fm频率设置-->
    <el-dialog :title="listTitle" :visible.sync="listShow" v-if="listShow" width="750px" :show-close="true" :close-on-click-modal="false" center>
      <list-tabs v-model="listShow" :listObj="listObj"></list-tabs>
    </el-dialog>
    <!--更换设备-->
    <el-dialog :visible.sync="changeDeviceShow" v-if="changeDeviceShow" width="600px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>更换设备</span> </div>
        <div class="line-title"></div>
      </div>
      <div>
        <change-device v-model="changeDeviceShow" :changeObj="changeObj" @getFatherEditDevice="getFatherEditDevice"></change-device>
      </div>
    </el-dialog>
    <!--历史位置-->
    <el-dialog :visible.sync="hisLocationShow" v-if="hisLocationShow" width="900px" :close-on-click-modal="false" top="10vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>{{locationTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 450px">
        <history-location v-model="hisLocationShow" :hisLocationObj="hisLocationObj"></history-location>
      </div>
    </el-dialog>
    <!--SOS呼叫号码、跌倒设置、语音设置、蓝牙功能、定位设置、室内定位、录音上传-->
    <el-dialog :visible.sync="listShow901" v-if="listShow901" width="1000px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-cat v-model="listShow901" :listObj="listObj"></list-tabs-cat>
    </el-dialog>
    <!--设备日志-->
    <el-dialog :visible.sync="deviceLogShow" v-if="deviceLogShow" width="900px" :close-on-click-modal="false" top="10vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>{{deviceLogTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 450px">
        <device-log v-model="deviceLogShow" :deviceLogObj="deviceLogObj"></device-log>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import deviceEdit from '../datamanagement/childComponents/deviceEdit'
import deviceAdd from '../datamanagement/childComponents/deviceAdd'
import deviceAdd1 from '../datamanagement/childComponents/deviceAdd1'
import {queryorg} from '../../api/organizer'
import { querybinddevice, deletedevicetohome, deletedevicetoperson, searchdevice, querybinddevicebyoid } from '../../api/device'
import { queryorghome } from '../../api/relation'
import { queryoldperson } from '../../api/serviceObject'
import { queryorgperson } from '../../api/orguser'
import {queryorgcommunity} from '../../api/community'
import deviceParam from '../datamanagement/childComponents/deviceParam'
import listTabs from '../datamanagement/deviceComponents/listTabs'
import changeDevice from '../datamanagement/deviceComponents/changeDevice'
import listTabsCat from '../datamanagement/deviceComponents/listTabsCat'
import historyLocation from './childComponents/historyLocation'
import DeviceLog from './childComponents/deviceLog'
export default {
  name: 'deviceTest',
  components: {deviceEdit, deviceAdd, deviceAdd1, deviceParam, listTabs, changeDevice, listTabsCat, historyLocation, DeviceLog},
  data () {
    return {
      isShowBindDevice: true,
      // 左边
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      orghomes: [],
      oldpersons: [],
      orgpersons: [],
      orgid: '',
      // 右边
      isonline: 0, // 0常规查询 1在线查询 2离线查询
      isonlinearr: [
        {name: '全部设备', id: 0},
        {name: '在线设备', id: 1},
        {name: '离线设备', id: 2}
      ],
      dtype: [700, 300, 901],
      dtypearr: [
        {name: '网关', id: 700},
        {name: '手表', id: 300},
        {name: '随身通', id: 901}
      ],
      searchKeyword: '',
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addShow1: false,
      addRow: {
        orgTree: [],
        orgcommunitys: [],
        orghomes: [],
        oldpersons: [],
        home: '',
        isGateway: false,
        row: '',
        orgids: [],
        isAddPerson: false // 是否添加人绑定设备
      },
      editShow: false,
      openWidth: '800px',
      subShow: false,
      subTitle: '',
      deviceRow: {},
      openDetails: false,
      voiceObj: {
        device: '',
        org: [],
        community: [],
        home: [],
        push_type: 2
      },
      telObj: {
        row: '',
        oldpersons: []
      },
      telShow: false,
      telTitle: '',
      listObj: {
        deviceRow: '',
        test: ''
      },
      listShow: false,
      listTitle: '',
      moduletag: '',
      changeDeviceShow: false,
      changeObj: {
        deviceRow: ''
      },
      hisLocationShow: false,
      locationTitle: '',
      hisLocationObj: {
        deviceRow: ''
      },
      // 901设置弹窗
      listShow901: false,
      // 设备日志弹窗
      deviceLogShow: false,
      deviceLogTitle: '',
      deviceLogObj: {
        deviceRow: ''
      }
    }
  },
  created () {
    this.isShowBindDevice = window.location.host !== ('newjky.wecare-u.net' || 'newhealth.wecare-u.net' || 'kangnh.com' || 'bengshan.kangnh.com') // 上海更换
    this.moduletag = this.$store.state.user.moduletag
    // 设备参数设置 搜索
    this.golobleObject.updateTableDevice = this.queryBindDevice
    this.orgid = this.$store.state.user.orgid
    this.getOrgData()
    this.getCommunity()
    this.getQueryOrgHome()
    this.getOldPerson()
  },
  mounted () {
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    getCommunity () {
      queryorgcommunity().then(res => {
        this.voiceObj.community = res.data.orgcommunitys
        this.addRow.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 左边树
    handleTreeClick (item) {},
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      this.addRow.orgids = this.isFirst
      if (this.isFirst.length === 0) {
        this.queryBindDevice()
      } else {
        this.queryBindDeviceByOid()
      }
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      this.loading = true
      queryorg().then(res => {
        // this.getQueryOrgHome()
        this.getUserTable()
        this.voiceObj.org = res.data.org
        this.addRow.orgTree = this.clone(res.data.org)
        this.orgData = res.data.org
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].orgpid === -1) {
            this.expandedKeys.push(this.orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 添加
    bindDevice () {
      this.addRow.row = ''
      this.addShow = true
      // let host = window.location.host
      // if (host === 'jiaold.com') {
      //   this.addRow.row = ''
      //   this.addShow = true
      // } else {
      //   this.addRow.row = ''
      //   this.addShow1 = true
      // }
    },
    // 家庭
    getQueryOrgHome () {
      queryorghome().then(res => {
        this.orghomes = res.data.orghomes
        this.addRow.orghomes = res.data.orghomes
      }).catch(() => {})
    },
    // 查询老人
    getOldPerson () {
      let data = {
        orgid: this.orgid
      }
      queryoldperson(data).then(res => {
        this.oldpersons = res.data.oldpersons
        this.addRow.oldpersons = res.data.oldpersons
      }).catch(() => {})
    },
    // 绑定者（平台人员）
    getUserTable () {
      this.loading = true
      queryorgperson().then(res => {
        this.orgpersons = res.data.orgpersons
        this.queryBindDevice()
      }).catch(() => {
        this.loading = false
      })
    },
    // 表格
    queryBindDevice () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: this.isonline
      }
      let data = {
        dtype: this.dtype
      }
      querybinddevice(params, data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {
        this.loading = false
      })
    },
    queryBindDeviceByOid () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: this.isonline
      }
      let data = {
        oids: this.isFirst,
        dtype: this.dtype
      }
      querybinddevicebyoid(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {})
    },
    getNoneWork (row) {
      let aa = row.p_nonetwork
      if (aa === '1') {
        return '开启'
      } else if (aa === '0') {
        return '关闭'
      } else {
        return aa
      }
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.h_phone !== '') {
          return row.h_phone
        } else {
          return row.p_phone
        }
      }
    },
    getOnHome (hid) {
      let address = ''
      for (let i = 0; i < this.orghomes.length; i++) {
        if (hid === this.orghomes[i].id) {
          address = this.orghomes[i].address
        }
      }
      return address
    },
    getOnPerson (row) {
      let oldPeople = ''
      if (row.pid !== 0) {
        for (let i = 0; i < this.oldpersons.length; i++) {
          if (row.pid === this.oldpersons[i].id) {
            oldPeople = this.oldpersons[i].name
          }
        }
      } else {
        for (let i = 0; i < this.oldpersons.length; i++) {
          if (row.hid === this.oldpersons[i].homeid) {
            oldPeople = this.oldpersons[i].name
          }
        }
      }
      return oldPeople
    },
    getOrgPersons (oid) {
      let userName = ''
      for (let i = 0; i < this.orgpersons.length; i++) {
        if (oid === this.orgpersons[i].id) {
          userName = this.orgpersons[i].name
        }
      }
      return userName
    },
    // 编辑设备
    editDevice (row) {
      // console.log(111)
      if (row.devicetype === 700) {
        this.openWidth = '800px'
      } else {
        this.openWidth = '600px'
      }
      this.addRow.row = row
      this.editShow = true
    },
    getFatherEditDevice () {
      this.queryBindDevice()
    },
    getFatherDevice () {},
    // 删除设备
    delDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endDelDevice(row)
      }).catch(() => {})
    },
    endDelDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将清除与此设备【' + name + '】有关的所有数据并解绑该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        if (row.devicetype === 300 || row.devicetype === 901 || row.devicetype === 350) {
          let data = {
            dids: [row.id]
          }
          deletedevicetoperson(data).then(res => {
            this.currentPage = 1
            this.queryBindDevice()
            this.$notify({
              title: '成功',
              message: '删除设备成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {})
        } else {
          let data = {
            dids: [row.id]
          }
          deletedevicetohome(data).then(res => {
            this.currentPage = 1
            this.queryBindDevice()
            this.$notify({
              title: '成功',
              message: '删除设备成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    openChange (row) {
      this.changeObj.deviceRow = row
      this.changeDeviceShow = true
    },
    queryDataTable () {
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    openSubList (row) {
      this.deviceRow = row
      this.subTitle = '【' + row.deviceid + '】' + '子机列表'
      this.subShow = true
    },
    openViceShow (row) {
      this.voiceObj.device = row
      this.openDetails = true
    },
    openTelShow (row) {
      let arr = []
      for (let i = 0; i < this.oldpersons.length; i++) {
        if (row.hid === this.oldpersons[i].homeid) {
          arr.push(this.oldpersons[i])
        }
      }
      this.telObj.oldpersons = arr
      this.telObj.row = row
      this.telTitle = '【' + row.deviceid + '】' + '电话本'
      this.telShow = true
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.pageSize = 10
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      }
    },
    searchWord () {
      this.currentPage = 1
      this.pageSize = 10
      this.searchWord1()
    },
    searchWord1 () {
      let data = {
        lessdeviceid: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        dtype: [700, 300, 901, 504, 507]
      }
      searchdevice(data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {})
    },
    openList (row) {
      this.listTitle = '【' + row.deviceid + '】' + '设置'
      this.listObj.deviceRow = row
      if (row.devicetype === 901) {
        this.listShow901 = true
        this.listObj.test = true
      } else {
        this.listShow = true
      }
    },
    openTrackMap (row) {
      this.locationTitle = '【' + row.deviceid + '】' + '历史位置'
      this.hisLocationObj.deviceRow = row
      this.hisLocationShow = true
    },
    openDeviceLog (row) {
      this.deviceLogTitle = '【' + row.deviceid + '】' + '日志'
      this.deviceLogObj.deviceRow = row
      this.deviceLogShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/deviceTest.vue